const TAXA_RELATORIO_EMPLACAMENTO = 15;
const TAXA_RELATORIO_INTENCAO_VENDA = 10;

const formatarMoedaBRL = (valor) => new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
}).format(valor);

const normalizarValorNumerico = (valor) => {
    if (typeof valor === 'number') {
        return Number.isFinite(valor) ? valor : 0;
    }
    if (typeof valor !== 'string') {
        return 0;
    }

    const texto = valor.trim();
    if (!texto) {
        return 0;
    }

    const negativo = texto.includes('-');
    const semMarcadores = texto
        .replace(/^'+/, '')
        .replace(/[^\d.,-]/g, '');

    if (!semMarcadores) {
        return 0;
    }

    const somenteNumero = semMarcadores.replace(/-/g, '');
    if (!somenteNumero) {
        return 0;
    }

    const possuiVirgula = somenteNumero.includes(',');
    if (possuiVirgula) {
        const partes = somenteNumero.split(',');
        const parteDecimal = partes.pop().replace(/\D/g, '');
        const parteInteira = partes.join('').replace(/\D/g, '');
        const numero = Number(`${parteInteira}.${parteDecimal}`);
        return negativo ? -numero : (Number.isFinite(numero) ? numero : 0);
    }

    const numero = Number(somenteNumero.replace(/[^\d.]/g, ''));
    return negativo ? -numero : (Number.isFinite(numero) ? numero : 0);
};

export {
    TAXA_RELATORIO_EMPLACAMENTO,
    TAXA_RELATORIO_INTENCAO_VENDA,
    formatarMoedaBRL,
    normalizarValorNumerico
};
